const scope_0 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;
const scope_1 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/global-scope.js').default;export default {
  ...scope_0,
...scope_1
}